import dbg from "core/application/Debug";
import msg from "core/application/Messenger";
import trl from "core/application/Translator";
import util from "core/application/Util";
import iframeChannel from "core/application/IframeChannel";

let hwcrypto = require("hwcrypto");


let signError = function (arg) {
    msg.error('error.signature');
    return Promise.reject(new Error("Signing failed " + arg));
};

let getCertificate = function () {
    return hwcrypto.getCertificate({
        lang: trl.getLanguage()
    });
};

let sign = function (cert, digest) {
    return hwcrypto.sign(cert, {
        type: 'SHA-256',
        value: util._hex2array(digest)
    }, {
        lang: trl.getLanguage()
    });
};

export class SignatureService {
    cert: { hex };

    /**
     * asynchronous signing service that takes as parameter 2 functions:
     *
     * 1. processCert - a function that takes the selected signature certificate
     * as parameter and must return a promise that resolves to an object
     * containing the hash to be signed.
     *
     * 2. finalizeSignature - a function that takes the final signature hash as
     * argument and needs to send it to backend to be added to the signeddoc in
     * processing.
     *
     * This method is for epit itself, client apps use the jschannel rpc methods
     * below
     */
    sign(processCert, finalizeSignature) {
        return getCertificate()
            .then((cert) => {
                this.cert = cert;
                return processCert(cert.hex);
            })
            .then((digest) => {
                return sign(this.cert, digest.digest);
            })
            .then((signature) => {
                return finalizeSignature(signature.hex);
            })
            .then(() => this.cert = null, signError);
    }
}

export let signatureService = new SignatureService();


let getCertificateInHost = function (transaction) {
    dbg.log('Certificate loading called via channel');
    transaction.delayReturn(true);

    getCertificate().then(function (cert) {
        signatureService.cert = cert;
        transaction.complete(cert);
    }, function (error) {
        transaction.error(error);
    });
};
iframeChannel.addBinding("getHostCertificate", getCertificateInHost);

let signDigestInHost = function (transaction, digest) {
    dbg.log('Signing process called via channel');
    transaction.delayReturn(true);

    dbg.log('Signing using previously selected certificate: ' + signatureService.cert.hex + ' and digest: ' + digest);

    sign(signatureService.cert, digest).then(
        (signature) => transaction.complete(signature),
        (error, msg) => transaction.error(error)
    );
};

iframeChannel.addBinding("signDigestInHost", signDigestInHost);




// WEBPACK FOOTER //
// ./src/main/ui/core/services/SignatureService.ts